import { getConfig } from '@/lib/config/config-registry';

/**
 * Builds the outbound header set for BFF / rotagen calls from the active host
 * config: `Content-Type`, and — when `auth.getAccessToken()` resolves a token —
 * `Authorization: Bearer <token>`. Async because the host's `getAccessToken` may
 * refresh before returning.
 *
 * The backend resolves the tenant from the bearer token, so no tenant header is
 * sent.
 */
export async function buildRequestHeaders(): Promise<HeadersInit> {
  const config = getConfig();
  const token = await config.auth.getAccessToken();

  return {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
}
